import React, { useEffect, useState } from "react";
import "../../assets/css/agent/user-tickets.scss";
import FeaturesTab from "../../components/FeaturesTab";
import RightBar from "../../components/RightBar";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import { BiSearch } from "react-icons/bi";
import { FaFilter } from "react-icons/fa";
import { AiOutlineReload } from "react-icons/ai";
import ReactPaginate from 'react-paginate';
import "../../assets/css/pagination.scss";
import axiosInstance from "../../environment/axiosInstance";

function UserTickets() {
    const { userId } = useParams();
    const history = useHistory();
    const [tickets, setTickets] = useState([]);
    const [ticketsCount, setTicketsCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    
    const useQuery = () => {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let searchParams = useQuery();

    useEffect(() => {
        let page = 1;

        if (searchParams.get("page")) {
            page = searchParams.get("page");
        }

        setPage(page);
        fetchTickets(page);
    }, [searchParams.get("page")]);

    useEffect(() => {
        const timer = setTimeout(() => {
            let page = 1;
    
            if (searchParams.get("page")) {
                page = searchParams.get("page");
            }
    
            setPage(page);
            fetchTickets(page);
          }, 2000);
      
          return () => clearTimeout(timer)
    }, [search]);

    const fetchTickets = (page) => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/customer/tickets/" + userId + "?page=" + page + "&q=" + search, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("user_token")}`
                }
            })
            .then(response => {
                if (response.data) {
                    // response.data.Data.docs.forEach(ticket => {
                    //     ticket.statusDropdownIsOpen = false;
                    // });
                    setTickets(response.data.Data.docs);
                    setTicketsCount(response.data.Data.totalDocs);
                    setTotalPages(response.data.Data.totalPages);
                }
            });
    }

    const handlePageClick = (event) => {
        history.push("/tickets/" + userId + "?page=" + (event.selected + 1));
    }

    const searchBarChange = (e) => {
        setSearch(e.target.value);
    }

    return (
        <div>
            {/* <Header />
            <UsersTabs /> */}
            <div className="user-tickets row m-0">
                {/* <div
                    className="p-0 left-col"
                    style={{
                        borderRight: "1px solid #D9D9D9"
                    }}
                >
                    <LeftBar />
                </div> */}
                <div className="p-0 center-col">
                    <FeaturesTab />
                    <div className="tickets-content">
                        <div className="top-bar">
                            <div className="left d-flex align-items-center">
                                <div
                                    className="searchDiv"
                                >
                                    <input
                                        type="search"
                                        value={search}
                                        className="form-control searchInput"
                                        onChange={searchBarChange}
                                    />
                                    <BiSearch
                                        className="searchIcon"
                                        size={20}
                                    />
                                </div>
                                <FaFilter
                                    size={20}
                                    color="#999999"
                                    className="ms-3 cursor-pointer"
                                />
                                <AiOutlineReload
                                    size={20}
                                    color="#999999"
                                    className="ms-auto cursor-pointer"
                                />
                            </div>
                        </div>
                        <table className="tickets-table table table-bordered">
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Dept</th>
                                <th>Channel</th>
                                {/* <th>Package</th> */}
                                <th>Subject</th>
                                <th>Assigned To</th>
                                <th>Status</th>
                                <th className="text-center">Action</th>
                            </tr>
                            {
                                tickets?.map(ticket => {
                                    return (
                                        <tr>
                                            <td>{ticket.ticket_id}</td>
                                            <td>{ticket.customer_name}</td>
                                            <td>{ticket.queryType?.name}</td>
                                            <td>{ticket.channel}</td>
                                            {/* <td>Premium</td> */}
                                            <td>{ticket.title}</td>
                                            <td>You</td>
                                            <td>{ticket.ticket_status}</td>
                                            <td>
                                                <Link
                                                    to={"/ticket/" + ticket.createdBy + "?id=" + ticket._id}
                                                    className="view-btn"
                                                >View</Link>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                        <ReactPaginate
                            breakLabel="..."
                            nextLabel=">"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={totalPages}
                            previousLabel="<"
                            renderOnZeroPageCount={null}
                            className="pagination"
                            activeClassName="active-page"
                            forcePage={page - 1}
                        />
                    </div>
                </div>
                <div
                    className="p-0 right-col"
                    style={{
                        borderLeft: "1px solid #D9D9D9"
                    }}
                >
                    <RightBar />
                </div>
            </div>
        </div>
    )
}

export default UserTickets;